enum MODAL_TYPES {
  ABOUT_ME = 'ABOUT_ME',
  CONTACT_INFO = 'CONTACT_INFO',
  FUN_FACT = 'FUN_FACT',
  IMAGE = 'IMAGE',
  QUOTE = 'QUOTE'
}

export default MODAL_TYPES;
